import React, { useEffect, useState } from 'react';
import { useForm } from '../../Form';
import Form from '../../Form/Form';
import Field from '../../Field';
import sessionsService from '../../../services/sessionsServices';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import Toast from '../../Toast';
import { DEFAULT_KAI_ID } from '../../ChatSection/KaiChatHeader';
import { RenameOverlay, RenameModalCard } from './RenameChatModal.style';

const RenameChatModal = ({ onClose, data }) => {
  const [form] = useForm();
  const [textString, setTextString] = useState(data?.title);
  const queryClient = useQueryClient();

  const handleSubmit = useMutation({
    mutationFn: async e => {
      return await sessionsService?.updateSession({
        platform_id: 'gramielabs',
        session_id: data?.id,
        user_id: '123',
        agent_id: data?.agent_id || DEFAULT_KAI_ID,
        title: e?.title,
      });
    },
    retry: 1,
    onSuccess: response => {
      Toast({
        type: 'success',
        message: response.detail,
      });
      queryClient.invalidateQueries({ queryKey: ['sessions'] });
      onClose();
    },
    onError: err => {
      Toast({
        type: 'error',
        message: err.detail,
      });
    },
  });

  useEffect(() => {
    if (data?.title) {
      const htmlString = textString;
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = htmlString;
      const plain = tempDiv.innerText.trim();
      setTextString(plain);
      form.setFieldsValue({
        title: plain,
      });
    }
  }, [data?.title]);

  return (
    <RenameOverlay onClick={onClose}>
      <RenameModalCard onClick={e => e.stopPropagation()}>
        <h3>Edit Chat Title</h3>
        <p className="subtitle">Give this chat a clearer name so you can find it later.</p>
        <Form form={form} onSubmit={e => handleSubmit.mutate(e)}>
          <Form.Item
            type="text"
            name="title"
            placeholder="Enter chat title"
            label="Chat Title"
            rules={[
              {
                required: true,
                message: 'Title is required',
              },
            ]}>
            <Field />
          </Form.Item>
          <div className="actions">
            <button type="button" className="cancel" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="submit" disabled={handleSubmit?.isPending}>
              {handleSubmit?.isPending ? 'Updating...' : 'Update'}
            </button>
          </div>
        </Form>
      </RenameModalCard>
    </RenameOverlay>
  );
};

export default RenameChatModal;
